<template>
  <span v-if="enabled && hasInspections" class="d-inline-flex align-center flex-nowrap">
    <v-menu v-model="menuOpen" offset-y :disabled="!hasReadyPdf">
      <template #activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" size="30" color="teal darken-1"
          :title="$t('damage_control.act.title')" :disabled="busy"
          data-testid="booking-act-icon" @click="activate">
          mdi-clipboard-check-outline
        </v-icon>
      </template>
      <v-list v-if="hasReadyPdf" dense data-testid="booking-act-menu">
        <v-list-item data-testid="booking-act-open" @click="openAct">
          <v-list-item-title>{{ $t('damage_control.entry.open_act') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :disabled="busy" data-testid="booking-act-pdf" @click="openActPdf(act.current_pdf)">
          <v-list-item-title>{{ $t('damage_control.act.download_pdf') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <a v-if="fallbackUrl" class="text-caption ml-1" :href="fallbackUrl" target="_blank" rel="noopener noreferrer">
      {{ $t('damage_control.act.pdf') }}
    </a>
    <v-icon v-if="errorText" small color="error" class="ml-1" role="alert" :title="errorText" :aria-label="errorText">
      mdi-alert-circle-outline
    </v-icon>
  </span>
</template>

<script>
import actDataMixin from "./actDataMixin";
import actPdfOpenMixin from "./actPdfOpenMixin";
import { readInitialSection } from "@/components/dashboard/cards/initialSection";

export default {
  name: "BookingActIcon",
  mixins: [actDataMixin, actPdfOpenMixin],
  props: {
    bookingId: { type: [Number, String], required: true },
    initialSection: { type: Object, default: undefined },
    initialEntityId: { type: [Number, String], default: undefined },
  },
  data: () => ({ menuOpen: false, appliedInitialEntity: null }),
  computed: {
    hasInspections() { return Boolean(this.act && this.act.inspections && this.act.inspections.length); },
    hasReadyPdf() { return Boolean(this.act && this.act.current_pdf && this.act.current_pdf.ready); },
  },
  watch: {
    contextKey() { this.menuOpen = false; },
    initialSection() { this.loadAct(); },
    initialEntityId() { this.loadAct(); },
  },
  methods: {
    resetActState() {
      ++this.loadSequence;
      this.act = null;
      this.errorText = "";
      this.loading = false;
    },
    applyInitialAct() {
      const section = readInitialSection(this.initialSection);
      if (!section.provided) return false;
      const entity = String(this.bookingId);
      if (this.initialEntityId !== undefined && String(this.initialEntityId) !== entity) {
        this.resetActState();
        this.appliedInitialEntity = null;
        return true;
      }
      if (!this.enabled) {
        this.resetActState();
        this.appliedInitialEntity = null;
        return true;
      }
      if (this.appliedInitialEntity === entity) return true;
      this.resetActState();
      this.appliedInitialEntity = entity;
      this.act = section.status === "ok" ? section.data : null;
      return true;
    },
    loadAct() {
      if (this.applyInitialAct()) return Promise.resolve();
      this.appliedInitialEntity = null;
      return actDataMixin.methods.loadAct.call(this);
    },
    activate() {
      if (!this.hasReadyPdf) this.openAct();
    },
    openAct() {
      if (!this.enabled || !this.hasInspections) return;
      this.menuOpen = false;
      return this.$router.push({ name: "damage-control-act", params: { booking_id: this.bookingId } });
    },
  },
};
</script>
